import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { RootState } from '../store';

export interface ISidebarState {
  value: boolean;
}

const initialState: ISidebarState = {
  value: localStorage.showSidebar === '1',
};

export const sidebarSlice = createSlice({
  initialState,
  name: 'sidebarSlice',
  reducers: {
    setSidebar: (state: any, action: PayloadAction<boolean>) => {
      state.value = action.payload;
      localStorage.setItem('showSidebar', action.payload ? '1' : '0');
    },
    toggleShow: (state: any) => {
      state.value = !state.value;
    },
    toggleToShow: (state: any) => {
      state.value = true;
    },
  },
});

export default sidebarSlice.reducer;

export const selectSidebar = (state: RootState) => state.sidebar.value;

export const { setSidebar, toggleShow, toggleToShow } = sidebarSlice.actions;
